import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewContainerRef } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { addSpacesToTypeName } from 'src/app/pipes/split-enum-strings/add-spaces.pipe';
import { LCS_SINGLE_SELECT_OPTIONS, LcsSingleSelectBase } from '../../single-select/single-select-base';
import { NameDirectoryPreferenceOption } from '../models/name-directory-preference-option';
import { nameDirectoryPreferenceOptionSelectors } from '../state/name-directory-preference-option.reducer';

@Component({
    providers: [
        {
            provide: LCS_SINGLE_SELECT_OPTIONS,
            useExisting: NameDirectoryPreferenceSelectComponent,
        },
    ],
    selector: 'ndt-name-directory-preference-select',
    templateUrl: './name-directory-preference-select.component.html',
    standalone: false
})
export class NameDirectoryPreferenceSelectComponent
   extends LcsSingleSelectBase<NameDirectoryPreferenceOption>
   implements OnInit
{
   nameDirectoryPreferences: Observable<NameDirectoryPreferenceOption[] | null>;

   constructor(
      protected elementRef: ElementRef,
      protected changeDetectorRef: ChangeDetectorRef,
      protected viewContainerRef: ViewContainerRef,
      private store: Store
   ) {
      super(elementRef, changeDetectorRef, viewContainerRef);
   }

   ngOnInit(): void {
      this.nameDirectoryPreferences = this.store.pipe(
         select(nameDirectoryPreferenceOptionSelectors.selectFilteredItems),
         map((items: any[]) => {
            return items.filter((item) => item.nameDirectoryPreference !== 'Disabled');
         }),
         this.itemsLoaded()
      );
   }

   displayWith(item: NameDirectoryPreferenceOption | null): string | null {
      return item?.nameDirectoryPreference ? addSpacesToTypeName(item.nameDirectoryPreference) : null;
   }

   trackBy(item: NameDirectoryPreferenceOption | null) {
      return item ? item.nameDirectoryPreference : null;
   }
}
